import { FC } from 'react'
import { HStack, VStack, Text, Box } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import { ColorMode } from '@chakra-ui/react'
import { useColorMode } from '@chakra-ui/react'
import Image from 'next/image'
import { HiOutlineLightBulb } from 'react-icons/hi'
import { BsArrowRight } from 'react-icons/bs'
import { RewardsRaffleEntryModal } from './RewardsRaffleEntryModal'

export const RewardsRaffle = () => {
  const { colorMode } = useColorMode()
  const isDarkMode = colorMode === 'dark'

  const coinBalance = 38138
  return (
    <Box
      mt='1.5rem'
      bg={isDarkMode ? 'cardBlack' : '#F9F9F9'}
      borderRadius='1.875rem'
      py={['1.5rem', '1.5rem', '2.5rem', '2.5rem']}
      px={['.5rem', '2.5rem', '2.5rem', '2.5rem']}
    >
      {/* <RewardsRaffleEntryModal /> */}
      <VStack gap='4'>
        <HStack w='full' h='full' justifyContent='space-between'>
          <HStack gap='2' w='full' h='full'>
            <Image
              src='/images/rewards/GemsShine.svg'
              width='50px'
              height='50px'
            />
            <VStack alignItems='flex-start'>
              <Text fontWeight='bold' fontSize={'1.15rem'}>
                {coinBalance}
              </Text>
              <Text
                color='#BDBDBD'
                fontSize='0.875rem'
                marginTop='0px !important'
              >
                Gems Balance
              </Text>
            </VStack>
          </HStack>
          <Button
            variant={isDarkMode ? 'primaryDark' : 'primary'}
            width='140%'
            h='50px'
          >
            Enter Raffle
          </Button>
        </HStack>
        <HStack
          bg={isDarkMode ? 'cardBlack' : '#E4EDFF'}
          padding='3'
          w='full'
          h='full'
          borderRadius='full'
          border='solid 1px'
          borderColor={isDarkMode ? '#BDBDBD' : '#B9D0FF'}
          justifyContent='space-between'
        >
          <HStack>
            <HiOutlineLightBulb
              size={25}
              color={isDarkMode ? 'white' : '#3276FF'}
            />
            <Text color={isDarkMode ? 'white' : '#3276FF'}>
              Check out new raffles to earn more coins
            </Text>
          </HStack>
          <HStack>
            <Text fontWeight='bold' color={isDarkMode ? 'white' : '#3276FF'}>
              Check it out
            </Text>
            <BsArrowRight
              size={20}
              strokeWidth='1'
              color={isDarkMode ? 'white' : '#B9D0FF'}
            />
          </HStack>
        </HStack>
      </VStack>
    </Box>
  )
}
